module.exports = __webpack_public_path__ + "photo_1_new.7f85587e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/building/full/photo_1_new.jpg
// module id = 631
// module chunks = 0